import { render, staticRenderFns } from "./input-fallback.vue?vue&type=template&id=7307e08b&scoped=true&"
import script from "./input-fallback.vue?vue&type=script&lang=js&"
export * from "./input-fallback.vue?vue&type=script&lang=js&"
import style0 from "./input-fallback.vue?vue&type=style&index=0&id=7307e08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7307e08b",
  null
  
)

export default component.exports